
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import {
  Table as MuiTable,
  TableBody,
  TableCell,
  TableContainer,
  TablePagination,
  TableHead,
  TableRow,
  Grid,
  Paper,
  InputAdornment,
  IconButton,
  Typography,
} from "@mui/material";
import { Input } from "../controls";
import { Box } from "@mui/system";

export default function Table(props) {
  const { t } = useTranslation();

  const {
    tblHead = [],
    tblData = [],
    HeaderComp = () => <div />,
    ActionComp = () => <div />,
    printMode = false,
  } = props;

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [_tblData, _setTblData] = useState(tblData);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleSerach = (e) => {
    _setTblData(
      tblData.filter((j) =>
        Object.keys(j).some((x) =>
          String(j[x])
            .toLowerCase()
            .includes(e.target.value.toLowerCase())
        )
      )
    );
    setPage(0);
  };

  useEffect(() => {
    _setTblData(tblData);
  }, [tblData]);

  const visibleRows = printMode
    ? _tblData
    : _tblData.slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage
      );

  return (
    <>
      {/* Search toolbar - normal mode only */}
      {!printMode && (
        <Paper
          className="br-8 shadow-xs"
          sx={{ marginBottom: "15px" }}
        >
          <Box className="d-flex p-10 j-between a-center d-wrap">
            <Box
              className="d-flex"
              sx={{
                minWidth: {
                  xs: "100%",
                  md: "250px",
                },
              }}
            >
              <HeaderComp />
            </Box>

            <Grid
              sx={{
                width: {
                  xs: "100%",
                  md: "250px",
                },
              }}
            >
              <Input
                label={t("search")}
                name="search"
                size="small"
                onChange={handleSerach}
                fullWidth
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton size="small">
                        <SearchRoundedIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
          </Box>
        </Paper>
      )}

      {/* Table */}
      <Paper
        className="br-8 shadow-xs"
        sx={{
          width: "100%",
          overflow: printMode ? "visible" : "hidden",
        }}
      >
        <TableContainer
          sx={{
            maxHeight: printMode
              ? "none"
              : "calc(100vh - 184px)",
            overflow: printMode ? "visible" : "auto",
          }}
        >
          <MuiTable
            stickyHeader={!printMode}
            aria-label="sticky table"
          >
            <TableHead>
              <TableRow>
                {tblHead.map((item, i) => (
                  <TableCell
                    key={i}
                    sx={{
                      fontSize: "16px",
                      backgroundColor:
                        "var(--primaryLight-color)",
                      color: "var(--primary-color)",
                      minWidth: "80px",
                      padding: "16px 8px 16px 16px",
                    }}
                  >
                    {item.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>

            <TableBody>
              {visibleRows.map((item, i) => (
                <TableRow hover key={i}>
                  {tblHead.map((headItem, index) => (
                    <TableCell
                      key={index}
                      sx={{
                        fontSize: "16px",
                        padding: "6px 16px",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {headItem.id === "actions" ? (
                        <ActionComp {...item} />
                      ) : (
                        item[headItem.id]
                      )}
                    </TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </MuiTable>

          {_tblData.length <= 0 && (
            <Typography
              variant="h6"
              className="tx-center p-30 tx-upp gray-color"
            >
              {t("dataNotAvailable")}
            </Typography>
          )}
        </TableContainer>

        {/* Pagination - normal mode only */}
        {!printMode && _tblData.length > 0 && (
          <TablePagination
            rowsPerPageOptions={[10, 25, 100]}
            component="div"
            labelRowsPerPage={t("rowsPerPage")}
            labelDisplayedRows={({ from, to, count }) =>
              t("displayedRows", {
                from,
                to,
                count:
                  count === -1
                    ? `more than ${to}`
                    : count,
              })
            }
            count={_tblData.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        )}
      </Paper>
    </>
  );
}
